export class User {
  $status: "unchanged" | "changed" | "inserted" | "deleted" = "unchanged";
  logon_id: string;
  firstname: string;
  lastname: string;
  email: string;
  role: string;
  enabled: boolean = true;
  retryCounter: number;
  newPassword: string;
}
